// Helper to read data from localStorage with mock fallback
// Used by admin panel to persist edits and by frontend to read updated data

export function getStoredData<T>(key: string, fallback: T): T {
  try {
    const stored = localStorage.getItem(key);
    if (stored) {
      const parsed = JSON.parse(stored) as T;
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
      if (!Array.isArray(parsed)) return parsed;
    }
  } catch {
    // ignore parse/read errors and return fallback
  }
  return fallback;
}